import React from 'react'
import CircularProgressBar from './CircularProgressBar'
export default function Skills() {
  return (
    <div  className='mainSkills'>
     
      <div id="Skills" className='SkillTitle'>  
      <br/>
         Skills 
      </div>       
      
      <table>
       <tr>
        <td className='sTd'><CircularProgressBar skill={"HTML"} level={90} color={'#23cf19'}/></td>
        <td className='sTd'><CircularProgressBar skill={"ReactJS"} level={70} color={'#19a8cf'}/></td>
        <td className='sTd'><CircularProgressBar skill={"Core JAVA"} level={80} color={'#d83838'}/></td> 
       </tr>
       <tr>
        <td className='sTd'><CircularProgressBar skill={"C"} level={90} color={'#a738d8'}/></td>
        <td className='sTd'><CircularProgressBar skill={"C++"} level={75} color={'orange'}/></td>
        <td className='sTd'><CircularProgressBar skill={"CSS"} level={50} color={'#cfc819'}/></td>
       </tr>
      </table>
    </div>
  )
}
